import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import React, { useCallback } from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { isClassicEditorHost } from '../../utils/get-editor-host';
import { showErrorModal } from './show-error-modal';
export const getFailedAnalyzeSiteModalProps = (t, editorHost, errorMessage) => ({
  content: isClassicEditorHost(editorHost) ? errorMessage : /*#__PURE__*/React.createElement(Text, null, errorMessage),
  primaryButtonText: t('accessibility-wizard.analyze-full-site.failed-to-analyze-site-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.analyze-full-site.failed-to-analyze-site-modal.secondary-button'),
  theme: 'destructive',
  title: t('accessibility-wizard.analyze-full-site.failed-to-analyze-site-modal.title')
});
export const useShowFailedAnalyzeSiteModal = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const showFailedAnalyzeSiteModal = useCallback(async _ref => {
    let {
      handleTryAgain,
      handleCancel,
      errorMessage
    } = _ref;
    biLogger.modalView({
      modalType: BiModalTypes.UnableToAnalyzeSite
    });
    await showErrorModal({
      ...getFailedAnalyzeSiteModalProps(t, editorHost, errorMessage),
      a11yWizardAdapter,
      editorHost,
      primaryButtonOnClick: async () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.TryAgain,
          modalType: BiModalTypes.UnableToAnalyzeSite
        });
        handleTryAgain == null || handleTryAgain();
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType: BiModalTypes.UnableToAnalyzeSite
        });
        handleCancel == null || handleCancel();
      }
    });
  }, [a11yWizardAdapter, biLogger, editorHost, t]);
  return showFailedAnalyzeSiteModal;
};
//# sourceMappingURL=show-failed-analyze-site-modal.js.map